// extracted by mini-css-extract-plugin
export default {"person":"person__1Fta-","text":"text__LyRPe","image":"image__2JBHw"};